<template>
	<div class="page">
		<div title="consultant" is='headered'></div>
		<div class="consultant_head">专家顾问</div>
		<!--图片瀑布流-->
		<div class="waterfallBox">
			<div class="waterfallItem_columu">
				<div v-for="consult in consultantArr1" class="waterfallItem">
					<img :src="consult.imgUrl" />
					<div class="waterfallItem_main">
						<div style="margin-bottom: 0px;" v-if="consult.nameEn" class="title">{{consult.nameEn}}</div>
						<div class="title">{{consult.name}}</div>
						<div v-for="text in consult.textList" class="text">{{text}}</div>
					</div>
				</div>
			</div>
			<div class="waterfallItem_columu">
				<div v-for="consult in consultantArr2" class="waterfallItem">
					<img :src="consult.imgUrl" />
					<div class="waterfallItem_main">
						<div class="title">{{consult.name}}</div>
						<div v-for="text in consult.textList" class="text">{{text}}</div>
					</div>
				</div>
			</div>
			<div class="waterfallItem_columu">
				<div v-for="consult in consultantArr3" class="waterfallItem">
					<img :src="consult.imgUrl" />
					<div class="waterfallItem_main">
						<div class="title">{{consult.name}}</div>
						<div v-for="text in consult.textList" class="text">{{text}}</div>
					</div>
				</div>
			</div>
			<div class="waterfallItem_columu">
				<div v-for="consult in consultantArr4" class="waterfallItem">
					<img :src="consult.imgUrl" />
					<div class="waterfallItem_main">
						<div style="margin-bottom: 0px;" v-if="consult.nameEn" class="title">{{consult.nameEn}}</div>
						<div class="title">{{consult.name}}</div>
						<div v-for="text in consult.textList" class="text">{{text}}</div>
					</div>
				</div>
			</div>
			<div class="waterfallItem_columu">
				<div v-for="consult in consultantArr5" class="waterfallItem">
					<img :src="consult.imgUrl" />
					<div class="waterfallItem_main">
						<div class="title">{{consult.name}}</div>
						<div v-for="text in consult.textList" class="text">{{text}}</div>
					</div>
				</div>
			</div>
		</div>

		<!--公共底部-->
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {
				consultantArr1: [
				{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/Jesu%CC%81s%20Marti%CC%81nez%20Almela.jpg',
						name: '马丁内斯·阿尔梅拉',
						nameEn: 'Jesús Martínez Almela',
						textList: [
							'国际项目管理协会IPMA主席',
							'国际工程项目管理专家。',
						]
					},
				{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/薛岩.jpg',
						name: '薛岩',
						textList: [
							'北京大学软件与微电子学院教授',
							'曾任国际项目管理协会IPMA副主席、中国双法项目管理研究委员会主任、中国双法与经济数学研究会理事。',
							'获2010年国际项目管理协会杰出研究贡献奖。'
						]
					},
					{
						imgUrl: 'https://static.feijingbang.com/upload/93de82de6bb84c7a96206fb60dc4e421',
						name: '李敏',
						textList: [
							'中国（优选法与统筹法）项目管理研究委员会委员',
							'国际项目管理专业资质认证IPMP评估师',
							'原北京奥组委综合处项目专家',
							'著名青少年教育专家，中国关心下一代工作委员会主任',
							'著《与孩子一起成长》',
						]
					},
				],
				consultantArr2: [{
						imgUrl: 'https://static.feijingbang.com/upload/76611196ed494f77b739f63bd79cc34d',
						name: '胡新渝',
						textList: [
							'原国家外专局副局长',	
							'中国国际人才交流基金会主任',
							'中国留学人才基金会理事长',
							'北京项目管理协会副会长',
							'中国项目管理领域元老级奠基人',
						]
					},{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/丁荣贵.jpg',
						name: '丁荣贵',
						textList: [
							'山东大学项目管理研究所所长',
							'教育部“新世纪优秀人才资助计划”获得者',
							'中国（优选法与统筹法）项目管理研究委员会委员',
							'国际项目管理协会IPMA研究委员会主席',
							'国际项目管理协会IPMA全球卓越大奖评估师'
						]
					},
					{
						imgUrl: 'https://static.feijingbang.com/upload/17c2722a6cd14952870ee3bf34a84cf7',
						name: '韩竹',
						textList: [
							'中国教育学会综合实践活动课程学术委员会委员',
							'中国民主北京东城区政协委员',
							'北京五中教育集团',
						]
					},
					
				],
				consultantArr3: [{
						imgUrl: 'https://static.feijingbang.com/upload/3ffc3d4669944bf8b1859b87243321da',
						name: '陈钟',
						textList: [
							'北京大学软件与微电子学院院长',
							'北京项目管理协会会长',
							'中国计算机信息保密委员会主任',
							'“影响中国软件开发的20人”',
						]
					},{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/燕继荣.jpg',
						name: '燕继荣',
						textList: [
							'北京大学长江学者、博导',
							'北京大学政府管理学院院长，北大公共治理研究所所长',
							'中国政治学会副会长',
						]
					},
					{
						imgUrl: 'https://static.feijingbang.com/upload/3d2279cfbd274d2daaa40d2dc97443df',
						name: '陈信祥',
						textList: [
							'教授级高工',
							'北京项目管理协会秘书长',
							'原首都信息发展股份有限公司原董事长',
							'美国项目管理学会PMI认证OPM3ProductSuite咨询师',
							'IPMP-A级国际项目经理',
							'PMI（中国）大奖评审专家委员会副主任'
						]
					},
					
				],
				consultantArr4: [{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/Veikko Valila 维克·沃雷勒.jpg',
						nameEn: 'Veikko Valila',
						name:'维克·沃雷勒',
						textList: [
							'原国际项目管理协会IPMA主席',
							'芬兰项目管理协会主席',
							'国际著名的项目风险管理专家',
						]
					},{
						imgUrl: 'https://static.feijingbang.com/upload/5f5e40c12d404e208e5ec74b7214d7a5',
						name: '马旭晨',
						textList: [
							'研究员（教授）级高工',
							'国际项目管理专业资质认证IPMP评估师',
							'中国（优选法与统筹法）项目管理研究委员会委员',
							'IPMP-A级国际项目经理',
							'原中国北方工业厦门公司总经理'
						]
					},
					{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/赵敏.jpg',
						name: '赵敏',
						textList: [
							'中国发明协会创新方法分会会长',
							'中国科协特聘创新萃智TRIZ专家',
							'对萃智TRIZ创新方法有深入研究',
							'著《三体智能革命》《TRIZ进阶及实战》等'
						]
					},
				],
				consultantArr5: [{
						imgUrl: 'https://static.feijingbang.com/upload/ebc3319ccc4742aa9548a597745a4800',
						name: '詹伟',
						textList: [
							'中国科学院大学工程科学学院教授博导',
							'国际项目经理IPMP认证评估师',
							'中国（优选法与统筹法）项目管理研究委员会副秘书长',
							'北京价值工程学会常务副会长',
							'北京工程管理科学学会理事'
						]
					},
					{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/郭雅.jpg',
						name: '郭雅',
						textList: [
							'北京项目管理协会副秘书长',
							'国际项目管理协会IPMA全球卓越大奖评估师',
							'IPMA中国青年委员会副主席',
							"曾获得'中国十大新锐项目管理培训师'的称号"
						]
					},
					{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/陶礼光.jpg',
						name: '陶礼光',
						textList: [
							'北京师范大学博导',
							'中国教育学会教育管理分会综合实践研究学术委员会理事长',
							'北京市教育科学研究院基础教育研究中心主任'
						]
					},
				],

				//				顾问相关
				carouselIndex: '', //业内专家顾问当前走马灯index
				consultantArr: [{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/Jesu%CC%81s%20Marti%CC%81nez%20Almela.jpg',
						name: '马丁内斯·阿尔梅拉',
						textList: [
							'国际项目管理协会IPMA主席',
							'国际工程项目管理专家。',
						]
					},
					{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/胡新渝.jpg',
						name: '胡新渝',
						textList: [
							'原国家外专局副局长',
							'中国国际人才交流基金会主任',
							'中国留学人才基金会理事长',
							'北京项目管理协会副会长',
							'中国项目管理领域元老级奠基人',
						]
					},
					{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/陈钟.jpg',
						name: '陈钟',
						textList: [
							'北京大学软件与微电子学院院长',
							'北京项目管理协会会长',
							'中国计算机学会信息保密委员会主任',
							'曾被评为“影响中国软件开发的20人”',
						]
					},
					{
						imgUrl: 'https://feijingbang.com/activity/anda/imgs/Veikko Valila 维克·沃雷勒.jpg',
						name: 'Veikko Valila 维克·沃雷勒',
						textList: [
							'曾任国际项目管理协会IPMA主席、秘书长',
							'芬兰项目管理协会主席',
							'国际著名的项目风险管理专家',
						]
					},
				],

			}
		},
		mounted() {},
		methods: {
			carouselChange(index) {
				this.carouselIndex = index;
			},
			changeConsultant(index) {
				let _this = this
				this.carouselIndex = index;
				this.$refs.carousel.setActiveItem(index);
			},

		}
	}
</script>

<style scoped="scoped">
	.consultant_head {
		width: 1200px;
		margin: 0 auto;
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	
	.index_consultant {
		padding-top: 10px;
		width: 1300px;
		margin: 0 auto;
		margin-bottom: 120px;
	}
	
	.consultantItem {
		width: 1200px;
		height: 384px;
		box-shadow: 0px 6px 14px rgba(150, 150, 150, 0.16);
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		border-radius: 10px;
	}
	
	.consultantItem_l {
		width: 384px;
		height: 384px;
		border-radius: 10px 0px 0px 10px;
	}
	.consultantItem_l img{
		width: 384px;
		height: 384px;
		border-radius: 10px 0px 0px 10px;
	}
	
	.consultantItem_r {
		width: 816px;
		height: 384px;
		padding-top: 60px;
		padding-left: 140px;
		text-align: left;
		border-radius: 0px 10px 10px 0px;
	}
	
	.consultantItem_r .title {
		line-height: 42px;
		font-size: 32px;
		font-weight: bold;
		margin-bottom: 20px;
	}
	
	.consultantItem_r .s_title {
		padding-left: 12px;
		line-height: 30px;
		font-size: 24px;
		position: relative;
		color: #51565D;
		margin-bottom: 12px;
	}
	
	.consultantItem_r .s_title::before {
		content: "";
		display: block;
		width: 4px;
		height: 4px;
		background-color: #4A7CFF;
		position: absolute;
		left: 0px;
		bottom: 10px;
	}
	/*走马灯底部控制*/
	
	.index_consultant_foot {
		width: 1200px;
		margin-top: 32px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	
	.index_consultant_foot .index_consultant_item {
		cursor: pointer;
		width: 282px;
		height: 90px;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 8px 14px rgba(150, 150, 150, 0.16);
	}
	
	.index_consultant_item>div {
		cursor: pointer;
		width: 282px;
		height: 90px;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-bottom: 4px solid #fff;
	}
	
	.index_consultant_item:hover {
		box-shadow: 0px 8px 14px rgba(150, 150, 150, 0.3);
	}
	
	.index_consultant_item>div div {
		line-height: 21px;
		font-size: 16px;
		font-weight: 560;
	}
	
	.index_consultant_item>.consultant_foot_sel {
		border-bottom: 4px solid #4A7CFF;
	}
	/*图片瀑布流*/
	
	.waterfallBox {
		position: relative;
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 120px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
	}
	
	.waterfallItem_columu {
		width: 220px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.waterfallItem {
		width: 220px;
		margin-bottom: 40px;
		background-color: #fff;
		/*box-shadow: 0px 8px 14px rgba(150, 150, 150, 0.16);*/
		box-shadow: 0px 6px 14px rgba(150, 150, 150, 0.8);
		border-radius: 10px;
		cursor: pointer;
		transition: all .2s;
		-moz-transition: all .2s;
		-webkit-transition: all .2s;
		-o-transition: all .2s;
	}
	.waterfallItem:hover{
		transform: scale(1.04);
	}
	.waterfallItem img {
		width: 220px;
		height: 220px;
		border-radius: 10px 10px 0px 0px;
	}
	
	.waterfallItem>.waterfallItem_main {
		padding: 30px 10px 30px 20px;
	}
	
	.waterfallItem>.waterfallItem_main>.title {
		line-height: 22px;
		font-size: 16px;
		text-align: left;
		margin-bottom: 20px;
	}
	
	.waterfallItem>.waterfallItem_main>.text {
		position: relative;
		line-height: 24px;
		font-size: 12px;
		color: #51565D;
		text-align: left;
		margin-bottom: 10px;
	}
	
	.waterfallItem>.waterfallItem_main>.text::after {
		content: '';
		display: block;
		width: 4px;
		height: 4px;
		background-color: #0080FF;
		position: absolute;
		left: -8px;
		top: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/consultant.vue